import globalTheme, { muiTheme } from '../global'
import XCircleIcon from '../../../atoms/icons/x-circle-icon'
import NotificationsIcon from '../../../atoms/icons/notifications-icon'
import CheckmarkCircleIcon from '../../../atoms/icons/checkmark-circle-icon'

const Alert = {
	MuiAlert: {
		defaultProps: {
			iconMapping: {
				error: <XCircleIcon />,
				info: <NotificationsIcon />,
				success: <CheckmarkCircleIcon />,
				warning: <NotificationsIcon />,
			},
			variant: 'filled',
		},
		styleOverrides: {
			action: {
				cursor: 'pointer',
				paddingLeft: globalTheme.spacing(3),
				marginLeft: 0,
			},
			icon: {
				marginRight: globalTheme.spacing(3),
				'& .MuiSvgIcon-root': {
					fontSize: 20,
				},
			},
			message: {
				padding: globalTheme.spacing('6px', 0),
			},
			root: {
				borderRadius: 0,
				justifyContent: 'space-between',
				padding: globalTheme.spacing('10px', 3),
			},
		},
	},
	MuiAlertTitle: {
		styleOverrides: {
			root: {
				fontWeight: muiTheme.typography.fontWeightBold,
			},
		},
	},
}

export default Alert
